import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextMono } from "./TextMono";
import { SourcesMono } from "./SourcesMono";


export default function Dia_Mono() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
    <TextCard 
            textcard={'Obesity Genes'  }
           />
    </Button>

<CustomDialog open={open} onClose={handleClose}

title='Obesity Genes'

content={<TextMono />}

sources={<SourcesMono />}

/>
</>
)}